import { useEffect } from 'react';

import styled from 'styled-components';

import { Box, Typography, Fade } from '@mui/material';

import Spin from 'components/Spin';
import { useMenu } from 'global/MenuContext';
import { PageRedirectExtras } from 'types/menuTypes';

interface PageRedirectProps {
  documentId: string;
}

const LoadingContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
  gap: 1.5rem;
  background: ${({ theme }) => theme.COLORS?.BACKGROUND_PRIMARY || '#ffffff'};
`;

const LoadingContent = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`;

const PageRedirect: React.FC<PageRedirectProps> = ({ documentId }) => {
  const { menu } = useMenu();
  const menuItem = menu.find(item => item.feature?.documentId === documentId);
  const extras = menuItem?.feature?.extras;

  const redirectTo = (extras as unknown as PageRedirectExtras)?.redirect_to;

  useEffect(() => {
    if (redirectTo) {
      // Small delay to show loading state
      const timer = setTimeout(() => {
        window.location.href = redirectTo;
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [redirectTo]);

  return (
    <LoadingContainer>
      <Fade in timeout={600}>
        <LoadingContent>
          <Spin size="large" />
          <Typography
            variant="h6"
            sx={{
              color: 'text.secondary',
              fontWeight: 500,
              textAlign: 'center',
            }}
          >
            Redirecionando...
          </Typography>
          {redirectTo && (
            <Typography
              variant="body2"
              sx={{
                color: 'text.disabled',
                textAlign: 'center',
                maxWidth: '400px',
              }}
            >
              Você será redirecionado em instantes
            </Typography>
          )}
        </LoadingContent>
      </Fade>
    </LoadingContainer>
  );
};

export default PageRedirect;
